var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav_search"},[_c('button',{staticClass:"button search"},[_c('search-icon',{staticClass:"svg-fill",attrs:{"size":"1.5x"}})],1),_c('input',{staticClass:"top-nav_input",attrs:{"placeholder":"Поиск","type":"text"}})])}
var staticRenderFns = []

export { render, staticRenderFns }